module.exports = __webpack_public_path__ + "img/UN_Women_Spurning02.241b918b.gif";